<template>
  <div class="periodical">
    <Empty v-if="!page.list.length" />
    <van-pullRefresh v-else v-model="page.refreshing" @refresh="onRefresh()">
      <van-List
        v-model="page.loading"
        :finished="page.finished"
        @load="onLoad()"
      >
        <div class="box" v-for="(item,index) in page.list" :key="index" @click="$router.push({ name:'PeriodicalDetail',params:{id:item.id} })">
          <div class="box_title">
            <van-image :src="item.defaultImage || require('@/assets/images/image_01.png')" fit="cover" class="img"></van-image>
            <div :class="{tag:true,tagBg1:item.activityStatus===3,tagBg2:item.activityStatus===1||item.activityStatus===2}">{{ statusList[item.activityStatus] }}</div>
          </div>
          <div class="box_content">
            <div class="title text-ellipsis">{{item.title}}</div>
            <div class="text">活动时间：{{item.startDate | formatDate('yyyy-MM-dd')}} - {{item.endDate | formatDate('yyyy-MM-dd')}}</div>
          </div>
        </div>
        <template #finished>
          <van-divider style="width:50%;margin:20px auto;">滑到底啦</van-divider>
        </template>
      </van-List>
    </van-pullRefresh>
  </div>
</template>

<script>
export default {
  name: 'Periodical',
  data () {
    return {
      page: {
        pageNo: 1,
        pageSize: 20,
        list: [],
        loading: false,
        finished: false,
        refreshing: false
      },
      statusList: ['', '未开始', '已过期', '征稿中']
    };
  },
  created () {
    this.onLoad();
  },
  methods: {
    onLoad () {
      const { page } = this;
      const params = {
        pageNo: page.pageNo,
        pageSize: page.pageSize
      };
      if (page.refreshing) {
        page.list = [];
        page.refreshing = false;
      }
      this.$http.get('solicit/list', { params, showLoading: true }).then((res) => {
        const data = res.data;
        if (!data.isHasNext) {page.finished = true;}
        page.pageNo = data.nextPage;
        page.list.push(...data.result);
        page.loading = false;
        this.page = page;
      });
    },
    onRefresh () {
      // 清空列表数据 重新加载数据
      this.page = {
        pageNo: 1,
        pageSize: 20,
        list: [],
        loading: true,
        finished: false,
        refreshing: true
      };
      this.onLoad();
    }
  }
};
</script>

<style lang="less" scoped>
.periodical {
  padding: 0 28px;
  .box {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 6px 60px rgba(0, 0, 0, 0.04);
    margin-bottom: 30px;
    &:nth-child(1) {
      margin-top: 30px;
    }
    .box_title{
      position: relative;
      .img{
        width: 100%;
        height: 344px;
        border-radius: 16px 16px 0px 0px;
      }
      .tag{
        position: absolute;
        top: -10px;
        left: 0;
        z-index: 4;
        width: 158px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: #fff;
      }
      .tagBg1 {
        background: url('~@/assets/images/study/bg_badge_04.png') no-repeat center center/cover;
      }
      .tagBg2 {
        background: url('~@/assets/images/study/bg_badge_05.png') no-repeat center center/cover;
      }
    }
    .box_content{
      padding: 28px;
      box-sizing: border-box;
      background-color: #fff;
      .title{
        font-size: 30px;
        font-weight: bold;
        line-height: 42px;
        color: #333444;
        margin-bottom: 12px;
      }
      .text{
        font-size: 24px;
        line-height: 34px;
        color: #999AAA;
      }
    }
  }
}
</style>